var map = {
	"./amphora.svg": 3808,
	"./anvil.svg": 7948,
	"./archer.svg": 4543,
	"./archery-target.svg": 7962,
	"./arrowhead.svg": 8807,
	"./backstab.svg": 6423,
	"./bad-gnome.svg": 5952,
	"./bandit.svg": 404,
	"./barbute.svg": 5623,
	"./barn.svg": 3389,
	"./barracks-tent.svg": 5891,
	"./barrel.svg": 7598,
	"./bat.svg": 1479,
	"./battle-axe.svg": 1723,
	"./bear-head.svg": 4247,
	"./beard.svg": 1900,
	"./bed.svg": 9363,
	"./bee.svg": 5634,
	"./beech.svg": 2431,
	"./bird-twitter.svg": 2589,
	"./black.svg": 7679,
	"./blacksmith.svg": 960,
	"./bloody-skeleton.svg": 5689,
	"./blue.svg": 2806,
	"./book-pile.svg": 5474,
	"./bowie-knife.svg": 7004,
	"./bowman.svg": 1110,
	"./broad-dagger.svg": 4357,
	"./broadsword.svg": 7121,
	"./brown.svg": 2898,
	"./brutal-helm.svg": 267,
	"./bully-minion.svg": 5601,
	"./caltrops.svg": 2984,
	"./campfire.svg": 5797,
	"./camping-tent.svg": 763,
	"./canoe.svg": 8456,
	"./castle.svg": 6298,
	"./cavalry.svg": 4884,
	"./cave-entrance.svg": 1348,
	"./centaur.svg": 2088,
	"./chariot.svg": 4042,
	"./chess-king.svg": 4410,
	"./chess-queen.svg": 8891,
	"./chest.svg": 4257,
	"./chicken.svg": 8447,
	"./cloaked-figure-on-horseback.svg": 4053,
	"./coral.svg": 6245,
	"./cow.svg": 8059,
	"./cowled.svg": 2690,
	"./crow-dive.svg": 386,
	"./crow-nest.svg": 6242,
	"./crowned-skull.svg": 9516,
	"./curled-tentacle.svg": 1194,
	"./cut-diamond.svg": 5573,
	"./dead-head.svg": 7047,
	"./deer.svg": 5066,
	"./defensive-wall.svg": 1222,
	"./diablo-skull.svg": 2709,
	"./dolphin.svg": 1446,
	"./door.svg": 7362,
	"./dragon-head.svg": 4190,
	"./drop.svg": 5149,
	"./duck.svg": 4209,
	"./dwarf-face.svg": 388,
	"./dwarf-helmet.svg": 5768,
	"./dwarf-king.svg": 7338,
	"./eagle-emblem.svg": 2821,
	"./electric.svg": 7743,
	"./elephant.svg": 8457,
	"./elf-helmet.svg": 7753,
	"./ent-mouth.svg": 2603,
	"./eyepatch.svg": 6317,
	"./family-house.svg": 9085,
	"./farmer.svg": 1091,
	"./flame.svg": 8255,
	"./forest.svg": 8929,
	"./frozen-orb.svg": 5068,
	"./full-wood-bucket-handle.svg": 607,
	"./furnace.svg": 5470,
	"./gargoyle.svg": 2886,
	"./gas-mask.svg": 5678,
	"./gate.svg": 8415,
	"./ghost.svg": 8123,
	"./giant-squid.svg": 6028,
	"./gladius.svg": 1285,
	"./golem-head.svg": 4953,
	"./grapes.svg": 2258,
	"./gray.svg": 9971,
	"./greek-sphinx.svg": 7537,
	"./hang-glider.svg": 5992,
	"./harpy.svg": 5086,
	"./haunting.svg": 1970,
	"./high-kick.svg": 2949,
	"./high-punch.svg": 2281,
	"./honey-jar.svg": 3551,
	"./hooded-assassin.svg": 6295,
	"./hooded-figure.svg": 6748,
	"./house.svg": 6902,
	"./hut.svg": 7717,
	"./imprisoned.svg": 9370,
	"./ionic-column.svg": 4883,
	"./jug.svg": 4408,
	"./juggler.svg": 3664,
	"./kangaroo.svg": 8120,
	"./kenku-head.svg": 4495,
	"./kiwi-bird.svg": 3589,
	"./labrador-head.svg": 5546,
	"./ladder.svg": 1982,
	"./ladle.svg": 5148,
	"./lever.svg": 6094,
	"./locked-chest.svg": 6075,
	"./locked-door.svg": 8497,
	"./manual-meat-grinder.svg": 1756,
	"./mounted-knight.svg": 7708,
	"./mummy-head.svg": 5654,
	"./mushroom.svg": 804,
	"./mustache.svg": 9519,
	"./old-wagon.svg": 6178,
	"./open-chest.svg": 170,
	"./orc-head.svg": 1251,
	"./overlord-helm.svg": 86,
	"./owl.svg": 7804,
	"./palette.svg": 4351,
	"./parrot-head.svg": 4957,
	"./peaks.svg": 3122,
	"./pig.svg": 9938,
	"./pine-tree.svg": 29,
	"./pirate-cannon.svg": 7365,
	"./pirate-captain.svg": 6266,
	"./pirate-flag.svg": 6144,
	"./plague-doctor-profile.svg": 2384,
	"./pocket-bow.svg": 7911,
	"./poison-bottle.svg": 379,
	"./polar-bear.svg": 4121,
	"./portculis.svg": 6589,
	"./present.svg": 1775,
	"./psychic-waves.svg": 9742,
	"./quiver.svg": 7496,
	"./red.svg": 5363,
	"./remedy.svg": 2670,
	"./robber.svg": 517,
	"./robe.svg": 5664,
	"./robot-golem.svg": 8057,
	"./rock-golem.svg": 598,
	"./rocking-chair.svg": 711,
	"./round-bottom-flask.svg": 3200,
	"./salmon.svg": 9740,
	"./saloon-doors.svg": 4630,
	"./scorpion.svg": 7849,
	"./scroll-quill.svg": 4253,
	"./sea-dragon.svg": 6397,
	"./secret-book.svg": 4104,
	"./sheep.svg": 3059,
	"./ship-wreck.svg": 5597,
	"./shooner-sailboat.svg": 9576,
	"./shoulder-bag.svg": 1807,
	"./sitting-dog.svg": 8579,
	"./skeleton.svg": 6563,
	"./skull-crossed-bones.svg": 5467,
	"./slime.svg": 4470,
	"./spark-spirit.svg": 7357,
	"./spider-alt.svg": 3891,
	"./spotted-mushroom.svg": 8076,
	"./square-bottle.svg": 8420,
	"./squid.svg": 2804,
	"./stairs-cake.svg": 2285,
	"./stairs.svg": 6420,
	"./standing-potion.svg": 9262,
	"./star-shuriken.svg": 634,
	"./stone-bust.svg": 2300,
	"./stone-pile.svg": 378,
	"./stone-wall.svg": 9258,
	"./strongbox.svg": 9782,
	"./sugar-cane.svg": 8841,
	"./swordman.svg": 531,
	"./swordwoman.svg": 2293,
	"./table.svg": 8938,
	"./tentacles-skull.svg": 295,
	"./tiger-head.svg": 2286,
	"./tipi.svg": 2338,
	"./tortoise.svg": 7219,
	"./toucan.svg": 7332,
	"./unicorn.svg": 7510,
	"./vampire-cape.svg": 9212,
	"./viking-head.svg": 2731,
	"./vile-fluid.svg": 1171,
	"./vine-leaf.svg": 6335,
	"./vulture.svg": 7554,
	"./warlord-helmet.svg": 5409,
	"./wasp-sting.svg": 3671,
	"./water-drop.svg": 3231,
	"./water-flask.svg": 1165,
	"./water-gallon.svg": 1455,
	"./waves.svg": 7352,
	"./werewolf.svg": 7281,
	"./wheat.svg": 3191,
	"./white-book.svg": 9393,
	"./white.svg": 3605,
	"./window-bars.svg": 4629,
	"./window.svg": 5730,
	"./wine-bottle.svg": 1454,
	"./wisdom.svg": 7755,
	"./witch-face.svg": 8967,
	"./wizard-staff.svg": 3778,
	"./wolf-head.svg": 1637,
	"./wood-cabin.svg": 297,
	"./wooden-chair.svg": 2212,
	"./wooden-crate.svg": 6646,
	"./wooden-door.svg": 8665,
	"./wyvern.svg": 4501
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5333;